import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  TextField,
  Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@material-ui/core';
import { NavigateNext, DoubleArrow } from '@material-ui/icons';
import {
  setSendSalesforceTargetName,
  setSendSalesforcePopFlg,
  createExternalFile,
  getMapping,
  setSendExternalResultPopFlg,
  setErrMsgSalesforceTargetName,
  setSalesforceMapObject,
  setSalesforceMapObjectName,
  setSalesforceMapModeKbn,
  setSalesforceMapColumnName,
  setSalesforceMapFieldList,
  setSalesforceMaxCheckCount,
  setExternalErrMsg,
} from '../../actions/TargetAction';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import {
  SEND_TYPE,
  MODE_KBN,
  MODE_KBN_NAME,
} from '../../../common/const';
import styles from './TargetPopSendSalesforceComponent.module.css';
import validator from '../../../common/validator';
import { getMessage } from '../../../common/util';
import { ERROR, INFO } from '../../../common/message';

/**
   * Salesforce送信確認POPUP
   */
class TargetPopSendSalesforceComponent extends Component {
  componentDidMount() {

  }

  componentDidUpdate(preProps) {
    const {
      sendSalesforcePopFlg,
      setSendSalesforceTargetNameAct,
      setErrMsgSalesforceTargetNameAct,
      getMappingAct,
      setSystemLodingFLgAct,
      setSalesforceMapObjectAct,
      setSalesforceMapObjectNameAct,
      setSalesforceMapModeKbnAct,
      setSalesforceMapColumnNameAct,
      setSalesforceMapFieldListAct,
      setSalesforceMaxCheckCountAct,
      companySearchList,
      setSendExternalResultPopFlgAct,
      setExternalErrMsgAct,
    } = this.props;

    if (preProps.sendSalesforcePopFlg !== sendSalesforcePopFlg
      && !sendSalesforcePopFlg) {
      // Popup表示フラグがfalseに変更された場合
      // ターゲットリスト名称初期化
      setSendSalesforceTargetNameAct('');
      // エラーメッセージ初期化
      setErrMsgSalesforceTargetNameAct('');
      setExternalErrMsgAct('');
    } else if (preProps.sendSalesforcePopFlg !== sendSalesforcePopFlg
      && sendSalesforcePopFlg) {
      // Salesforce連携マッピング取得
      const fetchMapping = async () => {
        const mapRes = await getMappingAct();
        if (mapRes) {
          setSalesforceMapObjectAct(mapRes.linkage_object);
          setSalesforceMapObjectNameAct(mapRes.linkage_object_name);
          setSalesforceMapModeKbnAct(mapRes.linkage_mode_kbn);
          setSalesforceMapColumnNameAct(mapRes.linkage_column_name);
          setSalesforceMapFieldListAct(mapRes.linkage_field_list);
          // 上限件数
          setSalesforceMaxCheckCountAct(mapRes.max_check_count);

          // 上限件数チェック
          // (チェック無の場合はmax_check_count=-1)
          if (mapRes.max_check_count
            && mapRes.max_check_count >= 0
            && companySearchList
            && companySearchList.all_count > mapRes.max_check_count) {
            // 上限超過メッセージ表示
            setSendExternalResultPopFlgAct(false, true);
          }
        }
      };

      setSystemLodingFLgAct(true);
      fetchMapping();
      setSystemLodingFLgAct(false);
    }
  }

  /**
   * ターゲットリスト名称入力桁数チェック
   */
  onBlurSalesforceTargetName = () => {
    const {
      sendSalesforceTargetName,
      // setErrTsrCdFlgAct,
      setErrMsgSalesforceTargetNameAct,
    } = this.props;

    const errMsg = [];
    if (sendSalesforceTargetName && sendSalesforceTargetName.length > 0) {
      // 桁数チェック
      validator.checkMaxLength(sendSalesforceTargetName, 50, errMsg);
      if (errMsg.length !== 0) {
        setErrMsgSalesforceTargetNameAct(getMessage(ERROR.E08009, errMsg.join(',')));
        return;
      }
    }
    setErrMsgSalesforceTargetNameAct();
  }

  /**
   * Salesforce連携データ作成
   */
  onClickSendExternal = async () => {
    const {
      createExternalFileAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    await createExternalFileAct(SEND_TYPE.SALESFORCE);
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      sendSalesforcePopFlg,
      setSendSalesforcePopFlgAct,
      sendSalesforceTargetName,
      setSendSalesforceTargetNameAct,
      companySearchList,
      sendExternalResultPopFlg,
      setSendExternalResultPopFlgAct,
      errMsgSalesforceTargetName,
      salesforceMapObject,
      salesforceMapObjectName,
      salesforceMapModeKbn,
      salesforceMapColumnName,
      salesforceMapFieldList,
      sendExternalLimitOverFlg,
      salesforceMaxCheckCount,
      externalErrMsg,
    } = this.props;

    if (!sendSalesforcePopFlg) {
      return null;
    }

    // 全体件数(3桁カンマ区切り)
    const allCount = (companySearchList)
      ? Number(companySearchList.all_count).toLocaleString()
      : 0;
    // MAX件数(3桁カンマ区切り)
    const maxCount = (salesforceMaxCheckCount)
      ? Number(salesforceMaxCheckCount).toLocaleString()
      : 0;

    // 送信区分表示
    let modeKbnName = '';
    if (MODE_KBN.INSERT === salesforceMapModeKbn) {
      modeKbnName = MODE_KBN_NAME.INSERT;
    } else if (MODE_KBN.UPSERT === salesforceMapModeKbn) {
      // Upsert時にキーとなる項目名で置換
      modeKbnName = MODE_KBN_NAME.UPSERT.replace('xxx', salesforceMapColumnName);
    }

    return (
      sendSalesforcePopFlg && (
        <div className={`${styles.sendSalesforcePop}`}>
          {(!sendExternalResultPopFlg
            && !sendExternalLimitOverFlg) && (
              <div className={`${styles.dialog}`}>
                <div className={`${styles.contents}`}>
                  <div className={`${styles.title}`}>Salesforce送信確認</div>
                  <div className={`${styles.errMessage}`}>{externalErrMsg}</div>
                  <div className={`${styles.message}`}>
                    ターゲティング結果
                    {' '}
                    {allCount}
                    件
                    {' '}
                    をSalesforceに送信します。
                  </div>
                  <Table className={`${styles.formBox}`}>
                    <TableBody>
                      <TableRow>
                        <TableCell className={`${styles.label} ${styles.leftTopRadius}`}>
                          <Typography>
                            ターゲットリスト名称
                            <br />
                            （50文字まで）
                          </Typography>
                        </TableCell>
                        <TableCell className={`${styles.itemCell} ${styles.rightTopRadius}`}>
                          <div className={`${styles.condition}`}>
                            <TextField
                              variant="outlined"
                              margin="normal"
                              value={sendSalesforceTargetName}
                              onChange={(e) => setSendSalesforceTargetNameAct(e.target.value)}
                              onBlur={this.onBlurSalesforceTargetName}
                              error={errMsgSalesforceTargetName}
                            />
                          </div>
                          <div className={`${styles.errorarea}`}>
                            {errMsgSalesforceTargetName}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={`${styles.label}`}>
                          <Typography>送信先オブジェクト</Typography>
                        </TableCell>
                        <TableCell className={`${styles.itemCell}`}>
                          <div className={`${styles.condition}`}>
                            <Typography className={`${styles.ellipsis}`}>
                              {salesforceMapObject}
                              {' '}
                              {salesforceMapObjectName}
                            </Typography>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={`${styles.label}`}>
                          <Typography>連携方式</Typography>
                        </TableCell>
                        <TableCell className={`${styles.itemCell}`}>
                          <div className={`${styles.condition}`}>
                            <Typography className={`${styles.ellipsis}`}>
                              {modeKbnName}
                            </Typography>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={`${styles.label} ${styles.leftBottomRadius}`}>
                          <Typography>送信先項目</Typography>
                        </TableCell>
                        <TableCell className={`${styles.itemCell} ${styles.rightBottomRadius} `}>
                          <div className={`${styles.condition}`}>
                            <div className={`${styles.tableWrapper}`}>
                              <div className={`${styles.scrollTable} `}>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell className={`${styles.sendTitle}`}>T-マーケティング</TableCell>
                                      <TableCell className={`${styles.sendTitle} ${styles.noBottomBorder}`} />
                                      <TableCell className={`${styles.sendTitle}`}>Salesforce</TableCell>
                                      <TableCell className={`${styles.sendTitle}`} />
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {salesforceMapFieldList?.map((item, index) => (
                                      <TableRow key={index}>
                                        <TableCell className={`${styles.alignTop}`}>{item.linkage_source_column_name || '　'}</TableCell>
                                        <TableCell className={`${styles.alignTop}`}>{' '}</TableCell>
                                        <TableCell className={`${styles.alignTop}`}>{item.linkage_target_column_name_en || '　'}</TableCell>
                                        <TableCell className={`${styles.alignTop}`}>{item.linkage_target_column_name || '　'}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                                <DoubleArrow className={`${styles.doubleArrow}`} />
                              </div>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <div className={`${styles.button}`}>
                    <Button
                      variant="contained"
                      className={`${styles.buttoncancel} cancel`}
                      onClick={() => {
                        setSendSalesforcePopFlgAct(false);
                      }}
                    >
                      キャンセル
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.onClickSendExternal}
                      disabled={(errMsgSalesforceTargetName && errMsgSalesforceTargetName !== '')}
                    >
                      <NavigateNext className={`${styles.setButtonIcon}`} />
                      送信
                    </Button>
                  </div>
                </div>
              </div>
          )}
          {/* 完了メッセージ */}
          {(sendExternalResultPopFlg
            && !sendExternalLimitOverFlg) && (
              <div className={`${styles.contentsMsg}`}>
                <div className={`${styles.messageCenter}`}>{INFO.I02001}</div>
                <div className={`${styles.buttonCenter}`}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setSendSalesforcePopFlgAct(false);
                      setSendExternalResultPopFlgAct(false);
                    }}
                  >
                    OK
                  </Button>

                </div>
              </div>
          )}
          {/* 件数超過メッセージ */}
          {(!sendExternalResultPopFlg
            && sendExternalLimitOverFlg) && (
              <div className={`${styles.contentsMsg}`}>
                <div className={`${styles.limitOverMessage} ${styles.bold}`}>
                  現在のターゲティング件数：
                  {allCount}
                  件
                </div>
                <div className={`${styles.limitOverMessage}`}>
                  上限件数を超えています。
                  <br />
                  {maxCount}
                  件以下になるよう検索設定タブで
                  <br />
                  絞り込み条件を追加してください。
                </div>
                <div className={`${styles.buttonCenter}`}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setSendSalesforcePopFlgAct(false);
                      setSendExternalResultPopFlgAct(false, false);
                    }}
                  >
                    OK
                  </Button>

                </div>
              </div>
          )}
        </div>
      ));
  }
}

export default connect(
  (state) => ({
    sendSalesforceTargetName: state.target.sendSalesforceTargetName,
    sendSalesforcePopFlg: state.target.sendSalesforcePopFlg,
    companySearchList: state.target.companySearchList,
    sendExternalResultPopFlg: state.target.sendExternalResultPopFlg,
    sendExternalLimitOverFlg: state.target.sendExternalLimitOverFlg,
    errMsgSalesforceTargetName: state.target.errMsgSalesforceTargetName,
    salesforceMapObject: state.target.salesforceMapObject,
    salesforceMapObjectName: state.target.salesforceMapObjectName,
    salesforceMapModeKbn: state.target.salesforceMapModeKbn,
    salesforceMapColumnName: state.target.salesforceMapColumnName,
    salesforceMapFieldList: state.target.salesforceMapFieldList,
    salesforceMaxCheckCount: state.target.salesforceMaxCheckCount,
    externalErrMsg: state.target.externalErrMsg,
  }),
  (dispatch) => ({
    setSendSalesforceTargetNameAct: (str) => dispatch(setSendSalesforceTargetName(str)),
    setSendSalesforcePopFlgAct: (bool) => dispatch(setSendSalesforcePopFlg(bool)),
    setSendExternalResultPopFlgAct:
    (resultPop, limitOverPop) => dispatch(setSendExternalResultPopFlg(resultPop, limitOverPop)),
    createExternalFileAct: (str) => dispatch(createExternalFile(str)),
    getMappingAct: () => dispatch(getMapping()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrMsgSalesforceTargetNameAct: (str) => dispatch(setErrMsgSalesforceTargetName(str)),
    setSalesforceMapObjectAct: (str) => dispatch(setSalesforceMapObject(str)),
    setSalesforceMapObjectNameAct: (str) => dispatch(setSalesforceMapObjectName(str)),
    setSalesforceMapModeKbnAct: (str) => dispatch(setSalesforceMapModeKbn(str)),
    setSalesforceMapColumnNameAct: (str) => dispatch(setSalesforceMapColumnName(str)),
    setSalesforceMapFieldListAct: (str) => dispatch(setSalesforceMapFieldList(str)),
    setSalesforceMaxCheckCountAct: (str) => dispatch(setSalesforceMaxCheckCount(str)),
    setExternalErrMsgAct: (str) => dispatch(setExternalErrMsg(str)),
  }),
)(TargetPopSendSalesforceComponent);
